import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../../addMedicationAdministered/selectors'
import {
  setAddToTimeLine,
  setDate,
  setDose,
  setDoseUnit,
  setMedication,
  setAssessedBy,
  setTime,
  setRoute,
} from '../../addMedicationAdministered/store/addMedicationAdministered.actions'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import { IOption, IOptions } from '../../../common/common.types'
import { setAddMedicationToTimeline } from '../store/quickActions.actions'
import { getAddMedicationAdministeredOptionsSelector } from '../../options/selectors'

export function* setMedicationQuickAction() {
  const addMedicationAdministeredState = yield select(getAddMedicationAdministeredSelector)
  const { addMedicationAdministeredData } = addMedicationAdministeredState
  const addMedicationAdministeredOptionsState = yield select(getAddMedicationAdministeredOptionsSelector)
  const { doseUnitOptions, performedByOptions, medicationsOptions, routeOptions } =
    addMedicationAdministeredOptionsState

  const userId = yield select(getUserIdSelector)

  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procId, routeId, doseObj } = props

  const medicationObj = medicationsOptions.filter((medication: IOption) => medication.id === +procId)

  if (medicationObj.length && medicationObj[0]) {
    yield put(setMedication(medicationObj[0], addMedicationAdministeredData[0]))
  }

  if (doseObj) {
    const separatedTitle = doseObj.split(' ')
    const dose = separatedTitle[0]
    const doseUnit: IOptions = doseUnitOptions.filter(
      (unit: IOption) => unit.name?.toUpperCase() === separatedTitle[1]?.toUpperCase()
    )

    yield put(setDose(dose, addMedicationAdministeredData[0]))
    yield put(setDoseUnit(doseUnit ? doseUnit[0] : null, addMedicationAdministeredData[0]))
  }

  if (routeId) {
    const route = routeOptions.filter((routeOption: IOption) => {
      return routeOption.id === Number(routeId)
    })
    yield put(setRoute(route ? route[0] : null, addMedicationAdministeredData[0]))
  }

  const assessedBy: IOptions = performedByOptions.find((option: IOption) => option.id === +userId)

  yield put(setTime(savedTimeString))
  yield put(setDate(currentDate))
  yield put(setAssessedBy(assessedBy ? assessedBy : null))
  yield put(setAddToTimeLine(true))
  yield put(setAddMedicationToTimeline(true))
}

export function* setMedicationQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_MEDICATION_BUTTON_TYPE], setMedicationQuickAction)
}
